import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeader } from './ui/SectionHeader';
import { BookOpenIcon, HeadphonesIcon, HeartPulseIcon, ScrollIcon } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: BookOpenIcon,
    title: 'The Italy Insider Protocol eBook',
    desc: 'The complete 6-chapter tactical manual covering first impressions, transit, dining, and emergencies.'
  }, {
    icon: HeadphonesIcon,
    title: 'The "High-Status" Audio Masterclass',
    desc: '48 minutes of "concierge-style" training you can listen to on the plane to lock in your tone and confidence.'
  }, {
    icon: HeartPulseIcon,
    title: 'The Emergency & Pharmacy Cheat Sheet',
    desc: 'Exactly what to say to get medical help fast without the "foreigner" confusion.'
  }, {
    icon: ScrollIcon,
    title: 'The "No-Tax" Script Vault',
    desc: 'Word-for-word scripts for taxis, hotels, and restaurants to ensure you get fair, local-level pricing.'
  }];
  return <section className="py-24 max-w-6xl mx-auto px-6" data-id="element-164">
      <SectionHeader eyebrow="What You Get" title="The Complete Protocol" centered={true} data-id="element-165" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16" data-id="element-166">
        {deliverables.map((item, index) => {
        const Icon = item.icon;
        return <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-167">
              <div className="bg-white p-8 border border-gold/20 rounded-sm hover:border-gold/50 transition-colors h-full flex flex-col items-center text-center group" data-id="element-168">
                <div className="w-16 h-16 rounded-full bg-emerald-900 flex items-center justify-center mb-6 shadow-md group-hover:scale-110 transition-transform duration-300" data-id="element-169">
                  <Icon className="w-8 h-8 text-gold" strokeWidth={1.5} data-id="element-170" />
                </div>
                <h3 className="text-xl font-serif text-emerald-900 mb-4" data-id="element-171">
                  {item.title}
                </h3>
                <p className="text-charcoal/70 font-sans font-light leading-relaxed" data-id="element-172">
                  {item.desc}
                </p>
              </div>
            </FadeIn>;
      })}
      </div>
    </section>;
}